/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDetailsRequest } from './';
import {
    ProjectDetailsRequestFromJSON,
    ProjectDetailsRequestFromJSONTyped,
    ProjectDetailsRequestToJSON,
} from './';
import type { ProjectDetailsTypeResource } from './';
import {
    ProjectDetailsTypeResourceFromJSON,
    ProjectDetailsTypeResourceFromJSONTyped,
    ProjectDetailsTypeResourceToJSON,
} from './';
import type { ProjectDurationChoiceRequest } from './';
import {
    ProjectDurationChoiceRequestFromJSON,
    ProjectDurationChoiceRequestFromJSONTyped,
    ProjectDurationChoiceRequestToJSON,
} from './';
import type { ProjectWeeklyAvailabilityResource } from './';
import {
    ProjectWeeklyAvailabilityResourceFromJSON,
    ProjectWeeklyAvailabilityResourceFromJSONTyped,
    ProjectWeeklyAvailabilityResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RecurringProjectDetailsRequest
 */
export interface RecurringProjectDetailsRequest extends ProjectDetailsRequest {
    /**
     * 
     * @type {ProjectWeeklyAvailabilityResource}
     * @memberof RecurringProjectDetailsRequest
     */
    freelancerAvailability: ProjectWeeklyAvailabilityResource;
    /**
     * 
     * @type {number}
     * @memberof RecurringProjectDetailsRequest
     */
    dailyFreelancerRate: number;
    /**
     * 
     * @type {ProjectDurationChoiceRequest}
     * @memberof RecurringProjectDetailsRequest
     */
    durationChoice: ProjectDurationChoiceRequest;
}

/**
 * Check if a given object implements the RecurringProjectDetailsRequest interface.
 */
export function instanceOfRecurringProjectDetailsRequest(value: object): value is RecurringProjectDetailsRequest {
    if (!('freelancerAvailability' in value) || value['freelancerAvailability'] === undefined) return false;
    if (!('dailyFreelancerRate' in value) || value['dailyFreelancerRate'] === undefined) return false;
    if (!('durationChoice' in value) || value['durationChoice'] === undefined) return false;
    return true;
}

export function RecurringProjectDetailsRequestFromJSON(json: any): RecurringProjectDetailsRequest {
    return RecurringProjectDetailsRequestFromJSONTyped(json, false);
}

export function RecurringProjectDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurringProjectDetailsRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDetailsRequestFromJSONTyped(json, ignoreDiscriminator),
        'freelancerAvailability': ProjectWeeklyAvailabilityResourceFromJSON(json['freelancerAvailability']),
        'dailyFreelancerRate': json['dailyFreelancerRate'],
        'durationChoice': ProjectDurationChoiceRequestFromJSON(json['durationChoice']),
    };
}

export function RecurringProjectDetailsRequestToJSON(value?: RecurringProjectDetailsRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDetailsRequestToJSON(value, true),
        'freelancerAvailability': ProjectWeeklyAvailabilityResourceToJSON(value['freelancerAvailability']),
        'dailyFreelancerRate': value['dailyFreelancerRate'],
        'durationChoice': ProjectDurationChoiceRequestToJSON(value['durationChoice']),
    };
}

